'use client';

import { t } from '@lingui/macro';
import { FormControl, FormControlLabel, Switch } from '@mui/material';
import { type FC, useCallback, useState } from 'react';
import { PrivateToggleAction } from './private-toggle.action';
type Props = {
  user: {
    id: string;
    is_private: boolean;
  };
};
export const PrivateToggle: FC<Props> = props => {
  const {
    user
  } = props;
  const [isPrivate, setIsPrivate] = useState<boolean>(user.is_private);
  const onToggle = useCallback(async (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    await PrivateToggleAction({
      userId: user.id,
      isPrivate: checked
    });
    setIsPrivate(checked);
  }, [setIsPrivate, user]);
  return <FormControl component="fieldset" data-sentry-element="FormControl" data-sentry-component="PrivateToggle" data-sentry-source-file="private-toggle.tsx">
      <FormControlLabel value="bottom" control={<Switch color="primary" checked={isPrivate} onChange={onToggle} size="small" />} label={isPrivate ? t`Profil privé` : t`Profil public`} labelPlacement="bottom" componentsProps={{
      typography: {
        fontSize: 10
      }
    }} data-sentry-element="FormControlLabel" data-sentry-source-file="private-toggle.tsx" />
    </FormControl>;
};